function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 7.65992L20.59 9.08001L17.36 5.85001L17.35 9.3201H17.34C17.3382 12.4146 16.1081 15.3819 13.92 17.57C11.7318 19.7582 8.76452 20.9883 5.67 20.99H3V18.99H5.67C8.23352 18.9864 10.691 17.9664 12.5037 16.1538C14.3164 14.3411 15.3364 11.8836 15.34 9.32008H15.35V5.84001L12.11 9.08001L10.69 7.66001L16.35 2.01001L22 7.65992Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.99927 14.9915H2.99927V16.9915H4.99927V14.9915Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.99927 10.9957H2.99927V12.9957H4.99927V10.9957Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.99927 7H2.99927V9H4.99927V7Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9949 18.9915V20.9915H20.9949V18.9915H18.9949Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9993 18.9915V20.9915H16.9993V18.9915H14.9993Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.99927 3.00427H2.99927V5.00427H4.99927V3.00427Z",
  fill: "currentColor"
});

var SvgFuturesWallet = function SvgFuturesWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFuturesWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/futuresWallet.d9a9b1fb.svg";
export { ForwardRef as ReactComponent };